import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

import { Grid } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";

import { Props } from "./interfaces";
import { DragAndDrop, Input, TextUpload } from "./styles";

const DragAndDropFiles = ({
  handleSetNewFiles,
  children,
  maxFilesNumberReached = false,
  customStyles,
  onlyAcceptedExtensions,
}: Props) => {
  const { t } = useTranslation();

  const containerId = uuidv4();

  return (
    <>
      {!maxFilesNumberReached && (
        <Grid sx={{ position: "relative", ...(customStyles ?? {}) }}>
          <Input
            id={containerId}
            multiple
            type="file"
            onChange={(e) => {
              handleSetNewFiles(e.target.files);
            }}
            accept={onlyAcceptedExtensions}
          />
          <label htmlFor={containerId}>
            <DragAndDrop
              onDragOver={(e) => e.preventDefault()}
              onDragEnter={(e) => e.preventDefault()}
              onDragLeave={(e) => e.preventDefault()}
              onDrop={(e) => e.preventDefault()}
            >
              <FontAwesomeIcon icon={faCloudUploadAlt} />
              <TextUpload>{`${t("components.drag_and_drop_files.input_placeholder")}`}</TextUpload>
            </DragAndDrop>
          </label>
        </Grid>
      )}

      {children}
    </>
  );
};

export default DragAndDropFiles;
